export default class RecentWork {
    constructor($el) {
        this.$el = $el;

        this.$filmToggle = this.$el.querySelector('[data-recent-work-toggle="film"]');
        this.$photographyToggle = this.$el.querySelector('[data-recent-work-toggle="photography"]');
        this.$filmImage = this.$filmToggle.closest('.recent-work__heading__item')
            .querySelector('.recent-work__heading__image');
        this.$photographyImage = this.$photographyToggle.closest('.recent-work__heading__item')
            .querySelector('.recent-work__heading__image');

        this.$filmSlider = this.$el.querySelector('[data-recent-work-category="film"]');
        this.$photographySlider = this.$el.querySelector('[data-recent-work-category="photography"]');
        this.$sliderStage = this.$el.querySelector('[data-recent-work-slider-stage]');

        this.$filmSlider.classList.add('recent-work__slider--fade-in');
        this.$photographySlider.classList.add('recent-work__slider--fade-in');
        this.$filmImage.classList.add('active');
        this.isTransitioning = false;

        this.$filmToggle.addEventListener('click', () => {
            this.switchSlider(
                this.$photographySlider,
                this.$filmSlider,
                this.$photographyToggle,
                this.$filmToggle,
                this.$photographyImage,
                this.$filmImage,
            );
        });
        this.$photographyToggle.addEventListener('click', () => {
            this.switchSlider(
                this.$filmSlider,
                this.$photographySlider,
                this.$filmToggle,
                this.$photographyToggle,
                this.$filmImage,
                this.$photographyImage,
            );
        });
    }

    /**
     * Fade out the current slider before hiding it and revealing the next one
     */
    switchSlider(
        $outgoingSlider,
        $incomingSlider,
        $outgoingToggle,
        $incomingToggle,
        $outgoingImage,
        $incomingImage,
    ) {
        if (this.isTransitioning || ! $incomingSlider.classList.contains('hidden')) {
            return;
        }

        this.isTransitioning = true;
        $outgoingToggle.classList.add('button--secondary');
        $incomingToggle.classList.remove('button--secondary');
        $outgoingImage.classList.remove('active');
        $incomingImage.classList.add('active');
        $outgoingSlider.classList.add('out');

        const finishTransition = (event) => {
            if (event.target !== $outgoingSlider) {
                return;
            }

            $outgoingSlider.removeEventListener('animationend', finishTransition);
            const outgoingHeight = $outgoingSlider.offsetHeight;
            $outgoingSlider.classList.add('hidden');
            $outgoingSlider.classList.remove('out');
            $incomingSlider.classList.remove('hidden');
            this.updateSwiper($incomingSlider);
            this.animateStageHeight(outgoingHeight, $incomingSlider.offsetHeight);
        };

        $outgoingSlider.addEventListener('animationend', finishTransition);
    }

    /**
     * A Swiper initialized inside display: none has no usable width until its
     * first reveal. Recalculate it before measuring the slider's height.
     */
    updateSwiper($slider) {
        const $swiper = $slider.querySelector('.swiper');

        if ($swiper && $swiper.swiper) {
            $swiper.swiper.update();
        }
    }

    /**
     * Animate the layout between sliders with different aspect ratios.
     */
    animateStageHeight(outgoingHeight, incomingHeight) {
        if (! this.$sliderStage || outgoingHeight === incomingHeight) {
            this.isTransitioning = false;
            return;
        }

        this.$sliderStage.style.height = `${outgoingHeight}px`;
        this.$sliderStage.getBoundingClientRect();

        requestAnimationFrame(() => {
            this.$sliderStage.classList.add('is-resizing');
            this.$sliderStage.style.height = `${incomingHeight}px`;
        });

        const finishResize = (event) => {
            if (event.target !== this.$sliderStage || event.propertyName !== 'height') {
                return;
            }

            this.$sliderStage.removeEventListener('transitionend', finishResize);
            this.$sliderStage.classList.remove('is-resizing');
            this.$sliderStage.style.removeProperty('height');
            this.isTransitioning = false;
        };

        this.$sliderStage.addEventListener('transitionend', finishResize);
    }
}
